import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import EPageHeader from '@/components/everridge/EPageHeader';
import { Button } from '@/components/ui/button';
import { useUserRole } from '@/features/identity/hooks/useUserRole';
import { Roles } from '@/@types/auth.types';
import useMediaQuery from '@/hooks/useMediaQuery';
import { AppConfig } from '@/config/app.config';
import { cn } from '@/lib/utils';
import { superAdminDataHubItems } from './data-hub.config';

const SuperAdminDataHubPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const userRole = useUserRole();
    const isMobile = useMediaQuery(AppConfig.mediaQueries.mobile);

    if (userRole !== Roles.superAdmin) return null;

    return (
        <section className={cn('flex flex-1 flex-col gap-6', isMobile && 'gap-4')}>
            <EPageHeader title={t('superAdmin.data.hub.title')} />
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
                {superAdminDataHubItems.map((item) => {
                    const Icon = item.icon;
                    return (
                        <Button
                            key={item.key}
                            variant="outline"
                            className="h-auto min-h-24 flex-col gap-3 px-6 py-6 text-left"
                            onClick={() => navigate(item.path)}
                        >
                            <Icon className="h-6 w-6" />
                            <span className="text-base font-medium">{t(item.titleKey)}</span>
                        </Button>
                    );
                })}
            </div>
        </section>
    );
};

export default SuperAdminDataHubPage;
